import { Stack } from '@mui/material';
import { ColDef } from '@siloreal:modules:private/silobag-list/config/extra/types';
import UTILS from '@siloreal:modules:private/silobag-list/config/extra/utils';
import { VriBadge } from '@siloreal:modules:private/silobag-list/config/ui/vri-badge';
import * as HOOKS from '@siloreal:shared:hooks';

export function buildVriColumn(): ColDef {
  return {
    field: 'vri',
    headerName: HOOKS.useLocale.getState().t('temp.private.list.silospro.vri'),
    headerAlign: 'center',
    minWidth: 84,
    sortable: false,
    renderCell: ({ row }) => {
      const vriTag = UTILS.extract.tag.vri(row);
      if (!vriTag) return null;

      return (
        <Stack height="100%" direction="row" justifyContent="center" alignItems="center">
          <VriBadge tag={vriTag} />
        </Stack>
      );
    },
  };
}
